import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";
import * as moment from "moment";

/**
 * Gibt die zur Verfügung stehenden Uhrzeiten an dem ein Termin erstellt werden kann zurück.
 * Vorhandene Termine oder blockierte Bereiche werden hier berücksichtigt.
 */
export function getAvailableTime(calendarId: number, timeFromLocale?: string): JQueryPromise<modelsGet.ITime[]>
{
    return api.get<modelsGet.ITime[]>({
        endpoint: "api/time",
        data: {
            calendarId: calendarId,
            timeFromLocale: timeFromLocale
        }
    });
}

export function getLocks(start?: moment.Moment, end?: moment.Moment, includeTime: boolean = false): JQueryPromise<modelsGet.ITimeLock[]>
{
    var endpoint = new URI("api/time/blocked");
    endpoint.addQuery({
        start: ((start != null) ? start.toISOString() : undefined),
        end: ((end != null) ? end.toISOString() : undefined),
        includeTime: includeTime
    });

    return api.get<modelsGet.ITimeLock[]>({
        endpoint: endpoint.href()
    });
}

export function getLock(id: number): JQueryPromise<modelsGet.ITimeLock>
{
    var endpoint = new URI("api/time/blocked");
    endpoint.segment(id.toString());

    return api.get<modelsGet.ITimeLock>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt eine Zeitspanne beginnend von "startLocale" bis 23:00 Uhr mit einer 15 Minuten iteration zurück.
 * @param starttime
 */
export function getCompleteTime(starttime?: string): JQueryPromise<any>
{
    return api.get<any>({
        endpoint: "api/time/complete",
        data: {
            starttime: (starttime != null) ? starttime : undefined
        }
    });
}

export function getCalendarMetadata(): JQueryPromise<modelsGet.IViewsMetadata>
{
    var uri: uri.URI = new URI();
    var endpoint = new URI("api/time/calendar-views");
    endpoint.segment(uri.getViewModeString());

    endpoint.addQuery({
        id: uri.getObjectId(),
        meta: JSON.stringify(uri.getMetadata()).toBase64urlString()
    });

    return api.get<modelsGet.IViewsMetadata>({
        endpoint: endpoint.href()
    });
}

export function getDatepickerMetadata(date: moment.Moment): JQueryPromise<modelsGet.IViewsMetadata>
{
    var uri: uri.URI = new URI();
    var endpoint = new URI("api/time/datepicker");

    endpoint.addQuery({
        dateTime: date.format()
    });

    return api.get<modelsGet.IViewsMetadata>({
        endpoint: endpoint.href()
    });
}

/**
 * Sperrt einen Zeitraum.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function postLock(lock: modelsPost.ILock): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/time/lock",
        data: JSON.stringify(lock)
    });
}

/**
 * Ändert einen gesperrten Zeitraum.
 * @param id Die ID eines geperrten Zeitraums.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function putLock(id: number, lock: modelsPost.ILock): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/time/lock/${id}`,
        data: JSON.stringify(lock)
    });
}

/**
 * Ändert die Bemerkung eines gesperrten Zeitraum.
 * @param id Die ID eines geperrten Zeitraums.
 * @param remark Die Begründung der Sperre.
 */
export function putLockDescription(id: number, description: string): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/time/lock/${id}/description`,
        data: JSON.stringify({
            Description: description
        })
    });
}

/**
 * Ändert einen gesperrten Zeitraum.
 * @param id Die ID eines geperrten Zeitraums.
 */
export function deleteLock(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/time/lock/${id}`
    });
}